import * as yup from "yup";

export const LoginValidate = yup.object().shape({
    email: yup.string().trim().required("El email es requerido"),
    password: yup.string().trim().required("El password es requerido"),
});

export const RegisterValidate = yup.object().shape({
    username: yup.string().trim().required("Ingresar el Nombre es requerido"),
    email: yup.string().trim().required("Ingresar el Correo electrónico es requerido"),
    password: yup.string().trim().required("Ingresar la Contraseña es requerido"),
    confpassword: yup.string().trim().required("Confirmar la Constraseña es requerido"),
});